export function createModule(name) {
  return class {
    constructor(syncClient) {
      this._moduleName = name;
      this._moduleManager = syncClient.modules;

      syncClient[name] = this;
    }

    onPacketReceived(packet) {
      const handler = this[this.packetHandlers[packet.type]];
      if (typeof handler === 'function') {
        handler.call(this, packet);
      }
    }
  };
}
